export enum ProxyRuleStatus {
    Unverified = 'unverified',
    Verifying = 'verifying',
    Verified = 'verified',
}
